const useErrors = (errors) => {
  const getError = (wellIndex) => {
    return errors[wellIndex];
  };

  const getErrorWells = () => {
    const list = [];
    for (const key in errors) {
      list.push(key);
    }
    return list;
  };

  return {
    getError,
    getErrorWells,
  };
};

export default useErrors;
